export const MIN_STAKED_BALANCE = 2000;
